import styled from 'styled-components';
export const ActionContainer = styled.div `
  margin-top: var(--space-400);
  display: flex;
`;
export const ConfigurePreviewContainer = styled.div `
  margin-block: var(--space-500);
`;
export const ConfigurePreviewContent = styled.div `
  display: flex;
  gap: var(--space-500);
  align-items: center;
`;
export const BannersContainer = styled.div `
  display: grid;
  gap: var(--space-400);
  margin-block: var(--space-400);
`;
export const ProductStatusAccordion = styled.div `
  margin-top: var(--space-400);
`;
export const LoaderContainer = styled.div `
  display: flex;
  justify-content: center;
`;
export const SubsectionContent = styled.div `
  display: grid;
  gap: var(--space-500);
`;
